import request from '@/utils/request.js'

export const getNewsList = (params) => {
    return request({
        url: '/api/article/list',
        method: 'GET',
        params
    })
};

export const getNewsLayout = (params) => {
    return request({
        url: '/api/article/layout',
        method: 'GET',
        params
    })
};
//查询文章详情
export const getNewsDetail = (params) => {
    return request({
        url: '/api/article/fetch',
        method: 'GET',
        params
    })
};
//查询

export const getBanner = (data) => {
    return request({
        url: '/api/info/fetch',
        method: 'POST',
        data
    })
};
